{
  "Binary": "Binär",
  "Calculation": "Berechnung",
  "Compensation-Plan": "Vergütungsplan",
  "Create-Account": "Konto erstellen",
  "Dashboard": "Dashboard",
  "Document-Import": "Dokumentenimport",
  "Document-Registry": "Dokumentenregister",
  "Entire-Network": "Gesamtes Netzwerk",
  "Finance-Payouts": "Auszahlungen",
  "Finance-Transactions": "Transaktionen",
  "Finance-Wallet-Balances": "Wallet-Guthaben",
  "Finance-Wallet-Import": "Wallet-Import",
  "Finance": "Finanzen",
  "Genealogy": "Genealogie",
  "Import-Tree": "Baum importieren",
  "Logs": "Protokolle und Berichte",
  "Logs-Activity-Log": "Aktivitätsprotokoll",
  "Logs-Export-History": "Exportverlauf",
  "Logs-Reports": "Berichte",
  "Manage-Accounts": "Kontenverwaltung",
  "Manage-Accounts-Roles": "Rollen",
  "Manage-Accounts-Accounts": "Konten",
  "Marketing-Activity": "Marketingaktivität",
  "Network": "Netzwerk",
  "Payment-system": "Zahlungssystem",
  "Profile": "Profil",
  "Reports": "Berichte",
  "Settings-Currencies": "Währungen",
  "Settings-Events": "Ereignisse",
  "Settings-Event-Settings": "Ereigniseinstellungen",
  "Settings-Wallets": "Wallets konfigurieren",
  "Settings-Payout-Methods": "Auszahlungsmethoden konfigurieren",
  "Settings-Localization": "Lokalisierung",
  "Settings-Preferences": "Einstellungen",
  "Settings-Profile-Fields": "Profilfelder konfigurieren",
  "Settings-Plan": "Planeinstellungen konfigurieren",
  "Settings": "Einstellungen",
  "Visual-Binary": "Visuelles Binär",
  "Visual-Genealogy": "Visuelle Genealogie",
  "Visual-Tree": "Visueller Baum",
  "Wallet": "Wallets",
  "Settings-Wallet-Transfer-Rules": "Wallet-Übertragungsregeln konfigurieren",
  "periodTypes": {
    "monthly": "Monatlich",
    "weekly": "Wöchentlich",
    "daily": "Täglich",
    "hourly": "Stündlich",
    "quarterHourly": "Alle 15 Minuten",
    "yearly": "Jährlich"
  }
}

